import { cx } from '@linaria/core';
import { avoidBreakInside } from '@provider/print';
import { CrossIcon, RoundedCheckmarkIcon } from '@ui/kit/icons';
import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { toggle, content, box, icon } from './_text-box.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TextBox(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  if (props.state === "input") {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      jsxs("button", {
        className: cx(box, props.className),
        "aria-description": props.checked ? `Fravælg element` : "Vælg element",
        "data-orientation": props.orientation,
        "data-checked": props.checked,
        "data-state": props.state,
        "data-page-context": pageContext,
        "data-theme": props.theme,
        onClick: props.onChange,
        children: [/*#__PURE__*/jsx("span", {
          className: toggle
        }), /*#__PURE__*/jsx("div", {
          className: content,
          children: props.children
        })]
      })
    );
  } else {
    const icon$1 = (() => {
      switch (props.state) {
        case "correct":
          return /*#__PURE__*/jsx(RoundedCheckmarkIcon, {});
        case "incorrect":
          return /*#__PURE__*/jsx(CrossIcon, {
            strokeWidth: 1.5,
            height: 10
          });
      }
    })();
    return /*#__PURE__*/jsxs("div", {
      className: cx(box, props.className),
      "data-orientation": props.orientation,
      "data-checked": props.checked,
      "data-state": props.state,
      "data-context": context,
      "data-page-context": pageContext,
      "data-theme": props.theme,
      ...avoidBreakInside({
        extend: {
          top: 9
        }
      }),
      children: [/*#__PURE__*/jsx("span", {
        className: toggle,
        "data-orientation": props.orientation,
        "data-checked": props.checked,
        "data-state": props.state
      }), /*#__PURE__*/jsx("div", {
        className: content,
        children: props.children
      }), icon$1 && /*#__PURE__*/jsx("span", {
        className: icon,
        "data-state": props.state,
        children: icon$1
      })]
    });
  }
}

export { TextBox };
//# sourceMappingURL=_text-box.js.map
